import { ActionContext, ActionTree } from 'vuex'
import { StoreInterface } from 'src/store'
import { MessageStateInterface } from 'src/store/message/state'
import { Message, MessageId } from 'able-lib'
import {
  getAnnouncement,
  getConversations,
  getUnAcknowledgePolicies,
  insertMessageAcknowledge,
  insertMessageAsNotification,
  readMessageNotification,
  updateMessageNotification
} from 'src/lib/queries/message'

import { axiosHttp } from 'boot/axios'
import { AxiosResponse } from 'axios'

const actions: ActionTree<MessageStateInterface, StoreInterface> = {
  // Lesson preparation

  async getConversations (context: ActionContext<MessageStateInterface, StoreInterface>, userIds: Array<number>) {
    const { data } = await getConversations(userIds)
    return data.conversations
  },

  // Announcement

  async loadAnnouncement ({ commit, rootState }: ActionContext<MessageStateInterface, StoreInterface>, announcementId: number) {
    const userId = rootState.user.user.id
    const { data } = await getAnnouncement(announcementId, userId)

    console.log(data.announcement)
    commit('SET_ANNOUNCEMENT', data.announcement)
  },

  async saveAnnouncement ({ rootState }: ActionContext<MessageStateInterface, StoreInterface>, announcement: any) {
    announcement.senderId = rootState.user.user.id
    const { data } = await insertMessageAsNotification(announcement, announcement.recipients)
    console.log(data)
  },

  async updateAnnouncement ({ state }: ActionContext<MessageStateInterface, StoreInterface>, announcement: any) {
    announcement.id = state.announcement.id
    announcement.contentId = state.announcement.content.id
    const { data } = await updateMessageNotification(announcement)

    console.log(data)
  },

  async readAnnouncement ({ rootState }: ActionContext<MessageStateInterface, StoreInterface>, announcementId: number) {
    const userId = rootState.user.user.id
    const { data } = await readMessageNotification(announcementId, userId)

    console.log(data)
  },

  async acknowledgeNotification ({ rootState }: ActionContext<MessageStateInterface, StoreInterface>, notificationId) {
    const userId = rootState.user.user.id
    const { data } = await insertMessageAcknowledge(notificationId, userId)
    console.log(data)
  },

  async emailAnnouncement (context: ActionContext<MessageStateInterface, StoreInterface>, announcementId: MessageId): Promise<boolean> {
    const result = await axiosHttp({
      method: 'POST',
      url: 'api/v1/emailAnnouncement',
      data: {
        id: announcementId
      }
    })
    return result.status === 201
  },

  // Tuition Tracker

  async generateTermsAndConditions (context: ActionContext<MessageStateInterface, StoreInterface>, data): Promise<AxiosResponse> {
    return axiosHttp({
      method: 'POST',
      url: 'api/v1/generateTermsAndConditions',
      data
    })
  },

  async emailTermsAndConditions (context: ActionContext<MessageStateInterface, StoreInterface>, data): Promise<AxiosResponse> {
    return axiosHttp({
      method: 'POST',
      url: 'api/v1/emailTermsAndConditions',
      data
    })
  },

  async generateAssessmentPermit (context: ActionContext<MessageStateInterface, StoreInterface>, data): Promise<AxiosResponse> {
    return axiosHttp({
      method: 'POST',
      url: 'api/v1/generateAssessmentPermit',
      data
    })
  },

  async emailAssessmentPermit (context: ActionContext<MessageStateInterface, StoreInterface>, data): Promise<AxiosResponse> {
    return axiosHttp({
      method: 'POST',
      url: 'api/v1/emailAssessmentPermit',
      data
    })
  },

  async emailConfirmationLetter (context: ActionContext<MessageStateInterface, StoreInterface>, data): Promise<AxiosResponse> {
    return axiosHttp({
      method: 'POST',
      url: 'api/v1/emailConfirmationLetter',
      data
    })
  },

  async emailDueDateReminder (context: ActionContext<MessageStateInterface, StoreInterface>, data): Promise<AxiosResponse> {
    return axiosHttp({
      method: 'POST',
      url: 'api/v1/emailDueDateReminder',
      data
    })
  },

  // Policy

  async loadUnAcknowledgePolicies ({ commit }: ActionContext<MessageStateInterface, StoreInterface>, userId) {
    const { data } = await getUnAcknowledgePolicies(userId)
    commit('SET_POLICIES', data.policies)
    return data.policies
  },

  async acknowledgePolicies ({ dispatch, rootState }: ActionContext<MessageStateInterface, StoreInterface>, messageId) {
    const userId = rootState.user.user.id
    const { data } = await insertMessageAcknowledge(messageId, userId)
    await dispatch('loadUnAcknowledgePolicies', userId)
    console.log(data)
  },

  async upsertAnnouncement ({ rootState, dispatch }: ActionContext<MessageStateInterface, StoreInterface>, announcement: Message): Promise<Message> {
    const myUser = rootState.user.user
    const copyMessage: Message = JSON.parse(JSON.stringify(announcement))
    if (announcement.id) delete copyMessage.messageGroups
    else {
      copyMessage.recipientUser = JSON.parse(JSON.stringify({ id: 0 }))
      copyMessage.senderUser = JSON.parse(JSON.stringify(myUser))
      copyMessage.messageGroups[0].group.userGroups[0].user = myUser
    }

    const { data } = await dispatch('upsertMessage', copyMessage)

    console.log('upsertAnnouncement', data)

    if (announcement.id) {
      return data.updatedMessage
    } else {
      return data.newMessage
    }
  }
}

export default actions
